import React from 'react';
import styled from '@emotion/styled';
import { Checkbox } from '@kompare/kompare-ui-library';
import { openContactModal, useAppDispatch } from 'src/common';
import { Button, Flex, Text } from 'src/components';
import { colors } from 'src/theme';

const CheckboxContainer = styled.div({
  backgroundColor: colors.primary4,
  borderRadius: 12,
  padding: 16,
});

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error: string;
  title: string;
  description: string;
  errorTitle: string;
  errorDescription: string;
  requestCallButtonText: string;
  /** When set, used instead of default openContactModal() for the "Zatraži poziv" button */
  onRequestCallClick?: () => void;
}

export const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  error,
  title,
  description,
  errorTitle,
  errorDescription,
  requestCallButtonText,
  onRequestCallClick,
}) => {
  const dispatch = useAppDispatch();

  return (
    <CheckboxContainer>
      <Flex vertical gap={16}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          checkboxSize="small"
          label={
            <Flex vertical gap={4}>
              <Text type="base" bold>{title}</Text>
              <Text type="small" color={colors.text2}>
                {description}
              </Text>
            </Flex>
          }
        />

        {error && (
          <Flex vertical gap={12} style={{ paddingLeft: 28 }}>
            <Flex vertical gap={4}>
              <Text type="small" bold color={colors.error1}>
                {errorTitle}
              </Text>
              <Text type="small" color={colors.error1}>
                {errorDescription}
              </Text>
            </Flex>
            <Button
              onClick={onRequestCallClick ?? (() => dispatch(openContactModal()))}
              btnType="outlinePrimary"
              size="medium"
              text={requestCallButtonText}
              className="btnBlock"
            />
          </Flex>
        )}
      </Flex>
    </CheckboxContainer>
  );
};
